import React from 'react';

var PlainText = function PlainText(_ref) {
  var plainTextEntry = _ref.plainTextEntry,
      className = _ref.className;
  return React.createElement("span", {
    className: className
  }, plainTextEntry.plainText);
};

export default PlainText;
//# sourceMappingURL=index.js.map
